import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';

import i18n from '../../../i18n';
import Layout from '../../../components/Layout';
import CsrfField from "../../../components/Form/CsrfField";
import FormField from "../../../components/Form/FormField";
import styles from '../styles';

const Reset = ({classes, errors, token}) => (
    <Layout>
        <div className={classes.main}>
            <Paper className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <Icon>restore</Icon>
                </Avatar>

                <Typography
                    component="h1"
                    variant="h5"
                    align="center"
                >
                    {i18n.get('user.password.reset')}
                </Typography>

                <form
                    method="POST"
                    action="/password/reset"
                    className={classes.form}
                >
                    <CsrfField/>

                    <input
                        type="hidden"
                        name="token"
                        value={token}
                    />

                    <FormField
                        id="email"
                        type="email"
                        name="email"
                        label={i18n.get('user.form.email')}
                        touched={errors.email}
                        error={errors.email && errors.email[0]}
                    />

                    <FormField
                        id="password"
                        type="password"
                        name="password"
                        label={i18n.get('user.form.password')}
                        touched={errors.password}
                        error={errors.password && errors.password[0]}
                    />

                    <FormField
                        id="password-confirm"
                        type="password"
                        name="password_confirmation"
                        label={i18n.get('user.password.confirm')}
                    />

                    <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.spaceButton}
                    >
                            {i18n.get('user.password.reset')}
                    </Button>
                </form>
            </Paper>
        </div>
    </Layout>
);

export default withStyles(styles)(Reset);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/auth/passwords/Reset.jsx